const { tokens: core } = require('../../core');
const { tokens: semantic } = require('../../semantic');
const { tokens: semanticInverted } = require('../../semantic-inverted');
const { tokens: inverted } = require('../../inverted-components');
const { tokens: standard } = require('../../standard-components');
module.exports = {
  core, semantic, semanticInverted, inverted, standard
};
